import "./scss/index.scss";
import classNames from "classnames";
import { RichText } from "prismic-reactjs";
import React from "react";
import { ResizeImage } from "@temp/@prismic/components/ResizeImage";
export function SliceProductFeatures(_ref) {
  var primary = _ref.primary,
      fields = _ref.fields;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "product-features"
  }, React.createElement("div", {
    className: "padding-left container"
  }, React.createElement("div", {
    className: "page-title"
  }, primary.title && React.createElement(RichText, {
    render: primary.title
  }))), fields && React.createElement("ul", {
    className: "product-features__list container padding-left"
  }, fields.map(function (item, i) {
    return React.createElement("li", {
      key: i,
      className: classNames("product-features__item", {
        "product-features__item-rate": item.text
      })
    }, React.createElement("div", {
      className: "product-features__item-image"
    }, item.image && React.createElement(ResizeImage, item.image), item.video && React.createElement("iframe", {
      className: "vimeo",
      src: "https://player.vimeo.com/video/".concat(item.video.video_id, "?autoplay=1&loop=1&muted=1&controls=0"),
      frameBorder: "0",
      allow: "autoplay",
      allowFullScreen: true,
      title: "video"
    })), React.createElement("div", {
      className: "product-features__item-content"
    }, React.createElement("div", {
      className: "product-features__item-title"
    }, item.sub_title && React.createElement(RichText, {
      render: item.sub_title
    })), React.createElement("div", {
      className: "product-features__item-descr"
    }, item.text && React.createElement(RichText, {
      render: item.text
    }))));
  }))), React.createElement("div", {
    className: "product-features-bottom__container container padding-left"
  }, React.createElement("div", {
    className: "product-features-bottom"
  }, primary.subtitle && React.createElement("div", {
    className: "product-features-bottom__top"
  }, React.createElement("div", {
    className: "product-features-bottom__title"
  }, primary.icon && React.createElement("img", {
    src: primary.icon.url,
    alt: primary.icon.alt
  }), primary.subtitle && React.createElement(RichText, {
    render: primary.subtitle
  })), React.createElement("div", {
    className: "product-features-bottom__descr"
  }, primary.text && React.createElement(RichText, {
    render: primary.text
  }))))));
}
SliceProductFeatures.componentName = "product_features";
export default SliceProductFeatures;